import router from '../../router';
const state = {
    bhaintPrasadCategories: [],
    userSession: null,
    categories: [],
    products: [],
    devices: []
}

const getters = {}

const actions = {
  printReceipt ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("http://localhost:8000/print/", params, {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  updateCategory({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/pos/category/updateCategory", params, {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  updateProduct({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/pos/product/updateProduct", params, {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  updateDevice({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/pos/device/updateDevice", params, {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  addProduct({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/pos/product/addProduct", params, {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  addDevice({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/pos/device/addDevice", params, {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  addCategory({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/pos/category/addCategory", params, {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  createBhandargharTicket({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/pos/ticket/createBhandargharTicket", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  createBookCentreTicket({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/pos/ticket/createBookCentreTicket", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  createOfficeTicket ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/pos/ticket/createOfficeTicket", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getBhainPrasadCategories ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/pos/category/getBhainPrasadCategories", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {
            commit('setBhaintPrasadCategories', response.data);
            resolve(response);
          })
        .catch ( error => (reject(error)));
    })
  },
  getMainCategories ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/pos/category/getMainCategories", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  searchProductByBarcode({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/pos/product/searchProductByBarcode", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  createUserSession ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/pos/session/createSession", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
         .then(response => {
              commit('setUserSession', response.data);
              resolve(response);
            })
        .catch ( error => (reject(error)));
    })
  },
  searchCustomer ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/pos/customer/searchCustomer", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getCatProductsByCatId ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/pos/category/getCategoriesProductByCatId", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
/*  getCategories({ commit }, params) {
    return new Promise((resolve, reject) => {
    axios
      .post("/pos/categories", params,{
          headers: {
            'Content-Type': 'application/json',
          }
        })
      .then(response => {
          commit('setCategories', response.data);
          resolve(response);
      })
      .catch ( error => (reject(error)));
    })
  },
*/
getCategories ({ commit }) {
    axios
      .get("/pos/categories")
      .then(response => (commit('setCategories', response.data)));
  },
  getDevices ({ commit }) {
      axios
        .get("/pos/devices")
        .then(response => (commit('setDevices', response.data)));
    },
  getProducts ({ commit }) {
      axios
        .get("/pos/products")
        .then(response => (commit('setProducts', response.data)));
    },
}

const mutations = {
  setBhaintPrasadCategories(state, data){
    state.bhaintPrasadCategories = data.data.data;
  },
  setUserSession(state, data){
    state.userSession = data.data.data[0];
  },
  setCategories(state,data){
    state.categories = data.data.data;
  },
  setProducts(state,data){
    state.products = data.data.data;
  },
  setDevices(state,data){
    state.devices = data.data.data;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
